const PROJECT_HISTORY_STATUSES = new Set(['completed', 'failed']);

export const selectProjectValidationHistory = (audits = []) =>
  audits.filter((audit) => PROJECT_HISTORY_STATUSES.has(audit.status));

export const projectAuditCount = (project = {}) => {
  const value = Number(project.audit_count);
  return Number.isFinite(value) && value >= 0 ? value : null;
};

export const projectLastAudit = (project = {}) =>
  project.last_audit ? new Date(project.last_audit) : null;

export const assessedElementComplianceDetail = (compliant, assessed) =>
  Number.isFinite(compliant) && Number.isFinite(assessed)
    ? `Fully compliant assessed elements ${compliant.toLocaleString()} / ${assessed.toLocaleString()}`
    : 'Reliable assessed-element aggregate unavailable';

export const unavailableIfcLabel = (availabilityStatus) =>
  availabilityStatus === 'expired'
    ? 'IFC expired — re-upload required'
    : 'IFC unavailable — re-upload required';
